export default __webpack_public_path__ + "static/media/logo2.58776ee8.png";